import { gql } from '@apollo/client';

const SellerInputFragment = gql`
  fragment SellerInputFragment on OdProtosSellReceptionData_SellerInput {
    uuid
    customerUuid
    address {
      uuid
      city
      latitude
      longitude
      postalCode
      result
      state
      street
      unitNumber
    }
    addressVerified
    addressVerifiedStatus
    addressUuid
    answerPrefillsJson
    answersJson
    opendoorDirectBuyboxThresholds {
      maxLotSqFt
      maxValuationCents
      minYearBuilt
    }
    channel
    experimentEntityId
    homeDetails {
      lastListing {
        listingId
        listDate
        listingPhotos
        realtorName
        realtorEmail
      }
      nearFloodZone
      photos
    }
    isListed
    region
    partnershipReferrals {
      identifier
      type
      userId
    }
    productOfferings {
      denialReason
      denialReasons
      deniedAt
      matchedAt
      product
      qualifiedAt
    }
    sellerFlowLastCompletedSlug
    sellerFlowUuid
    sellerFlowName
    attributes {
      selfServiceVirtualAssessmentGroup
    }
    homeValue {
      headlinePrice {
        value
      }
      headlineRangeLower {
        value
      }
      valuationCeilingCents
      comps {
        addressUuid
      }
      variance: expectedError
    }
    denialPartnerIdentifier
  }
`;

export default SellerInputFragment;
